import axios from 'axios'
import config from '../config'
import {
    Message
} from 'element-ui';
import {
    startLoading,
    endLoading
} from '../processing'
import {
    handleError
} from '../index'
import qs from 'qs'
import cookie from 'js-cookie'
import quit from '@/common/quit.js'
axios.defaults.baseURL = config.baseURL

function authHeader() {
    return {
        'x-auth-token': cookie.get('token')
    }
}

let base64 = ''
// const handleError = (error) => {
//     let response = error.response
//     if (response && (response.status == 401 || response.status == 403)) {
//         quit()
//     } else {
//         if (response && error.response.data) {
//             Message.error(error.response.data.message)
//         } else {
//             Message.error(error.toString())
//         }
//     }
// }
export default {
    AdminManagementRegion: async (data, type) => {
        startLoading();
        try {
            if (type === 'remove') {
                await axios.delete(`/region`, {
                    params: data,
                    headers: authHeader()
                })
            } else if (type === 'add') {
                await axios.post('/region', data, {
                    headers: authHeader()
                })
            } else if (type === 'update') {
                await axios.put('/region', data, {
                    headers: authHeader()
                })
            }

            endLoading()
            return 'success'
        } catch (error) {
            endLoading()
            handleError(error)
        }
    },
    AdminRegionList: async () => {
        startLoading();
        try {
            const result = await axios.get(`/region`, {
                headers: authHeader()
            })
            endLoading()
            return result.data
        } catch (error) {
            endLoading()
            handleError(error)
        }
    },
    AdminRegionById: async (regionId) => {
        startLoading();
        try {
            const result = await axios.get(`/region/${regionId}`, {
                headers: authHeader()
            })
            endLoading()
            return result.data
        } catch (error) {
            endLoading()
            handleError(error)
        }
    },
    getManagerList: async () => {
        startLoading();
        try {
            const result = await axios.get('/group/user', {
                params: {
                    role: 'ROLE_REGION_MANAGER'
                },
                headers: authHeader()
            })
            endLoading()
            return result.data
        } catch (error) {
            endLoading()
            handleError(error)
        }
    },
    AdminEditRegionProvince: async (data, type) => {
        startLoading();
        try {
            if (type === "addProvince") {
                await axios.post('/region/district', data, {
                    headers: authHeader()
                })
            } else if (type === "removeProvince") {
                await axios.delete('/region/district', {
                    params: data,
                    headers: authHeader()
                })
            }

            endLoading()
            return 'success'
        } catch (error) {
            endLoading()
            handleError(error)
        }
    },
    regionAuthStation: async (data) => {
        startLoading();
        try {
            await axios.put('/region/station/authorize', data, {
                headers: authHeader()
            })
            endLoading()
            return 'success'
        } catch (error) {
            endLoading()
            handleError(error)
        }
    },
}


// WEBPACK FOOTER //
// ./src/http/componentsAPI/admin.js